module.exports = __webpack_public_path__ + "img/mindful.14f5c0df.webp";